"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".maintenance[_ngcontent-%COMP%]{background:#f1f9fa;padding:140px 25px;position:inherit}.maintenance[_ngcontent-%COMP%]   h1.title[_ngcontent-%COMP%]{font-size:38px;margin-top:0;margin-bottom:40px;color:#3f3f3f}.maintenance[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{font-size:20px;color:#696969}@media (max-width:768px){.maintenance[_ngcontent-%COMP%]{min-height:800px;position:static}}"];
exports.styles = styles;

